import clsx from "clsx";
import React, {FunctionComponent, useEffect, useState} from "react";
import InputText from "./InputText";
import Input, {InputProps} from "./Input";

type ColorPickerProps = InputProps<string>;

const ColorPicker: FunctionComponent<ColorPickerProps> = ({value, name, cssClass, ...inputAttr}) => {
    const [textInputValue, setTextInputValue] = useState(value);
    const [colorInputValue, setColorInputValue] = useState(inputAttr.placeholder || textInputValue);

    useEffect(() => {
        setTextInputValue(value);

        const newColor = getResolvedColor(value || inputAttr.placeholder || "");
        setColorInputValue(newColor);
    }, [value, inputAttr.placeholder]);

    const getResolvedColor = (value: string) => {
        if (value.length === 4 && value.startsWith("#")) {
            return value.split("").map((it) => `${it}${it}`).join("").slice(1);
        }
        return value;
    };

    return (
        <div className={clsx("color-picker", cssClass)}>
            <InputText
                name={name}
                value={textInputValue}
                {...inputAttr}
            />
            <Input
                type="color"
                value={colorInputValue}
                {...inputAttr}
            />
        </div>
    );
};

export default ColorPicker;
